import { useMediaQuery } from "@mui/material";
import type { Theme } from "@mui/material/styles";
import { useDockState, useDockWidth } from "./dockStore";

/** Десктоп помощника: боковая панель; ниже md лист на весь экран. */
export const useIsAssistantDesktop = () =>
  useMediaQuery((theme: Theme) => theme.breakpoints.up("md"), { noSsr: true });

/**
 * Отступ справа для области страницы, пока открыта боковая панель
 * помощника: панель стоит рядом со страницей, а не поверх неё.
 * animate: false во время перетаскивания края, чтобы отступ не отставал.
 */
export function useAssistantDockInset(enabled: boolean): {
  inset: number;
  animate: boolean;
} {
  const desktop = useIsAssistantDesktop();
  const { open, resizing } = useDockState();
  const width = useDockWidth();
  return {
    inset: enabled && desktop && open ? width : 0,
    animate: !resizing,
  };
}
